import VueRouter, { RouteConfig } from 'vue-router'

const List = () => import('../views/clazz-mgt/List.vue')
const Edit = () => import('../views/clazz-mgt/Edit.vue')
const Remove = () => import('../views/clazz-mgt/Remove.vue')
const Settings = () => import('../views/clazz-mgt/Settings.vue')
const GradeClazzList = () => import('../views/clazz-mgt/GradeClazzList.vue')
const DupStudent = () => import('../views/clazz-mgt/RemoveDuplicateStudent.vue')

export const listRoute: RouteConfig = {
  path: '/clazz-mgt-list',
  name: 'clazz_mgt_list',
  component: List,
  meta: {
    title: '班级管理',
  },
}

export const gradeClazzListRoute: RouteConfig = {
  path: '/clazz-mgt-grade-clazz-list',
  name: 'clazz_mgt_grade_clazz_list',
  component: GradeClazzList,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '班级管理',
  },
}

export const editRoute: RouteConfig = {
  path: '/clazz-mgt-edit',
  name: 'clazz_mgt_edit',
  component: Edit,
  props: (route) => ({
    ...route.query,
    ...route.params,
    forCurSchool: route.query.forCurSchool !== 'false',
  }),
  meta: {
    title: '更换执教班级',
  },
}

export const removeRoute: RouteConfig = {
  path: '/clazz-mgt-remove',
  name: 'clazz_mgt_remove',
  component: Remove,
  meta: {
    title: '班级管理',
  },
}

export const settingsRoute: RouteConfig = {
  path: '/clazz-mgt-settings',
  name: 'clazz_mgt_settings',
  component: Settings,
  props: (route) => ({ ...route.query }),
  meta: {
    title: '班级管理',
  },
}

export const dupStudentRoute: RouteConfig = {
  path: '/clazz-mgt-dup-student',
  name: 'clazz_mgt_dup_student',
  component: DupStudent,
  props: (route) => ({ ...route.query }),
  meta: {
    title: '重复学生',
  },
}

export default [listRoute, editRoute, removeRoute, settingsRoute, gradeClazzListRoute, dupStudentRoute]

export function navigateToClazzMgtList(router: VueRouter) {
  router.push({ name: listRoute.name })
}

export function navigateToGradeClazzMgtList(router: VueRouter, gradeNo: number) {
  router.push({ name: gradeClazzListRoute.name, query: { gradeNo: `${gradeNo}` } })
}

export function navigateToClazzMgtEdit(router: VueRouter, forCurSchool = true, schoolId?: string) {
  router.push({ name: editRoute.name, query: { forCurSchool: `${forCurSchool}`, schoolId } })
}

export function navigateToClazzMgtRemove(router: VueRouter) {
  router.push({ name: removeRoute.name })
}

export function navigateToClazzMgtSettings(router: VueRouter, from?: string) {
  router.push({ name: settingsRoute.name, query: { from } })
}

export function navigateToClazzMgtDupStudent(router: VueRouter, clazzId: string | number) {
  router.push({ name: dupStudentRoute.name, query: { clazzId: clazzId + '' } })
}
